import { ProgressIndicator } from "@asosteam/asos-web-component-library-progress-indicator";
import style from "./styles";

const PremierDeliveryLoading = () => (
  <div className={style.PremierDeliveryLoading}>
    <ProgressIndicator
      className={style.PremierLoadingSpinner}
      progressMessage="Loading Indicator"
      size="large"
      transparent
    />
  </div>
);

export default PremierDeliveryLoading;
